export default __webpack_public_path__ + "static/media/15019.d8c49ce4.jpg";